import { render, staticRenderFns } from "./LiquidacionAdministrativoDetalle.vue?vue&type=template&id=0362c192&scoped=true&"
import script from "./LiquidacionAdministrativoDetalle.vue?vue&type=script&lang=js&"
export * from "./LiquidacionAdministrativoDetalle.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionAdministrativoDetalle.vue?vue&type=style&index=0&id=0362c192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0362c192",
  null
  
)

export default component.exports